<template>
  <div>
   
    <el-dialog
      :visible="userinfoDetailDialogVisible"
      title="修改用户信息"
      width="900px"
      @close="closeDialog"
    >
      <el-form
        ref="elForm"
        :model="updateForm"
        size="medium"
        label-width="140px"
      >
        <el-row :gutter="15">
          <el-form-item label="用户的userID" prop="userId">
            <!-- <el-input
              v-model="accountInfo.userId"
              placeholder="请输入用户的userId"
              clearable
              :style="{ width: '100%' }"
            >
            </el-input> -->
            <el-input v-model="updateForm.accountInfo.userId" disabled>

            </el-input>
          </el-form-item>
          <el-form-item label="用户类型" >
            <el-select
              v-model="updateForm.accountInfo.type"
              placeholder="请选择账户类型用户类型"
              clearable
              :style="{ width: '100%' }"
            >
              <el-option
                v-for="(item, index) in typeOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否可交易"  >
            <el-switch
              v-model="updateForm.accountInfo.allowTrade"
              active-color="#49F909"
            ></el-switch>
          </el-form-item>
          <el-form-item label="是否可划入"  >
            <el-switch
              v-model="updateForm.accountInfo.allowTransfer"
              active-color="#49F909"
            ></el-switch>
          </el-form-item>
          <el-form-item label="是否开关仓"  >
            <el-switch
              v-model="updateForm.accountInfo.allowOpenPosition"
              active-color="#49F909"
            ></el-switch>
          </el-form-item>
          <el-form-item label="用户状态" >
            <el-select
              v-model="updateForm.userInfo.state"
              placeholder="请选择用户状态"
              clearable
              :style="{ width: '100%' }"
            >
              <el-option
                v-for="(item, index) in stateOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户组别" >
            <el-select
              v-model="updateForm.userInfo.userGroupId"
              placeholder="请选择用户组别"
              clearable
              :style="{ width: '100%' }"
            >
              <el-option
                v-for="(item, index) in userGroupIdOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSave('elForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'updatedialog',
  props:['updateForm'],
  data() {
    return {
      changeForm: {
        id: '',
        tel: '',
        email: '',
        telCountryCode: '86'
      },
       accountInfo: {
        userId: null,
        type: 0,
        allowTrade: true,
        allowTransfer: true,
      },
      userInfo: {
        state: 1,
        userGroupId:1,
      },
      //  rules: {
      //   userId: [
      //     {
      //       required: true,
      //       message: "请输入用户的userId",
      //       trigger: "blur",
      //     },
      //   ],},
        typeOptions: [
        {
          label: "普通账户",
          value: 0,
        },
        {
          label: "量化账户",
          value: 1,
        },
        {
          label: "风险保证金账户",
          value: 2,
        },
      ],
      stateOptions: [
        {
          label: "0",
          value: 0,
        },
        {
          label: "1",
          value: 1,
        },
      ],
      userGroupIdOptions:[
        {
          label: "1",
          value: 1,
        },
        {
          label: "2",
          value: 2,
        },
        {
          label: "3",
          value: 3,
        },
      ],
      
    };
  },
  watch: {
    // userinfoDetail(val, oldVal) {
    //   if (val !== oldVal) {
    //     this.changeForm = { ...val };
    //   }
    // },
    userinfoDetailDialogVisible(){
      this.elForm={...this.updateForm}
    }
  },
  computed: {
    ...mapState('user', [
      'userinfoDetail',
      'userinfoDetailDialogVisible',
      'countryCodeList'
    ]),
    ...mapGetters('user', ['userList'])
  },
  methods: {
    ...mapMutations('user', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail'
    ]),
    ...mapActions('user', ['updatInfo', 'coutryCode','resetPassword','updateUser']),
    closeDialog() {
      this.setUserinfoDetailDialogVisible(false);
    },
    close() {
      this.setUserinfoDetailDialogVisible(false);
    this.$refs["elForm"].resetFields();
    this.dialogVisible=false
  },
    handleSave() {
      const accountInfo=this.updateForm.accountInfo
      const userInfo=this.updateForm.userInfo
    this.updateUser({
      userId:this.updateForm.accountInfo.userId,
      state:this.updateForm.userInfo.state,
      userGroupId:this.updateForm.accountInfo.userGroupId,
      allowTrade:this.updateForm.accountInfo.allowTrade,
      allowTransfer:this.updateForm.accountInfo.allowTransfer,
      type:this.updateForm.accountInfo.type
    }).then(res=>{
      this.$message.success('修改成功')
          this.close()
    }).catch(()=>{
      this.close()
    })
      // let updateInfo = {
      //   id: this.changeForm.id,
      //   tel: this.changeForm.tel,
      //   email: this.changeForm.email,
      //   telCountryCode: this.changeForm.telCountryCode
      // };
      // this.updatInfo(updateInfo);
    },
    resetLoginPassword(id){
      this.resetPassword({userId:id}).then(()=>{
        this.$message.success('重置成功！');
        
      })
    }
  },
  created() {
    // this.coutryCode();
  }
};
</script>

<style lang="less" scoped>
::v-deep.el-select {
  .el-input__inner {
    width: 100px;
  }
}
</style>
